// The app shell: TopBar + routed content. Shell contract: this and TopBar
// render only feature-agnostic chrome (back button, empty slots);
// feature-specific UI is mounted by each feature via TopBarSlot.

import {Outlet} from "react-router-dom";
import {TopBarProvider} from "../TopBarContext";
import {useNavigationJournal} from "../../../navigation/backNavigation";
import {TopBar} from "./TopBar";
import classes from "../App.module.css";

export const AppShellMain = () => {
    // Mirrors every visited location for the back button's origin awareness.
    useNavigationJournal();

    return (
        <TopBarProvider>
            <TopBar />
            <div className={classes.mainContent}>
                <Outlet />
            </div>
        </TopBarProvider>
    );
};
